import getKey from "@/clir/utils/getKey";
import setKey from "@/clir/utils/setKey";

const prefixStringKey = (object, path, { defaut, prefix }) => {
    const tmp = getKey(object, path);
    if (typeof tmp !== "string" && typeof tmp !== "number") {
        if (typeof defaut !== "string") return "";
        return `${prefix}${defaut}`;
    }
    return `${prefix}${tmp}`;
};

/**
 * Fonctions utilitaires de manipulation d'objets javascript exposées sous forme de mixins
 *
 *
 * @author <span><span class="fw-bold">Nicolas Huber</span><a class="ms-2" href="mailto:dmod-huber.consultant@dgfip.finances.gouv.fr">dmod-huber.consultant@dgfip.finances.gouv.fr</a></span>
 * <br/>
 * <span><span class="fw-bold">Pascal Ouzeau</span><a class="ms-2" href="mailto:pascal.ouzeau@dgfip.finances.gouv.fr">pascal.ouzeau@dgfip.finances.gouv.fr</a></span>
 * @since Version 1.1
 * @version 1.2.1
 * @displayName objectUtils
 *
 */

export default {
    methods: {
        getKey,
        setKey,
        prefixStringKey
    }
}
